import { Motion } from './util/motion/index'; //入场动画库 使用animate.css
import AOS from 'aos';//aos动画库
import 'aos/dist/aos.css';
import { createApp } from 'vue'
import router from './router'
import { createPinia } from 'pinia'
import App from './App.vue'
import AetherIcon from '@/components/icon/AetherIcon.vue'; // 图标组件
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
//引入el样式公共样式
import 'element-plus/dist/index.css'
import 'virtual:uno.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import '@/styles/element/custom.scss'
import '@/styles/variables.scss'
import 'aos/dist/aos.css';

import 'highlight.js/styles/atom-one-dark.css';
import 'highlight.js/lib/common';
import hljsVuePlugin from '@highlightjs/vue-plugin';
// 预加载图标库
import { addCollection } from '@iconify/vue';
import ep from '@iconify/json/json/ep.json'
import ri from '@iconify/json/json/ri.json'
import carbon from '@iconify/json/json/carbon.json'
addCollection(ep)
addCollection(ri)
addCollection(carbon)
const app = createApp(App);

app.use(router)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .use(hljsVuePlugin)
  .use(createPinia())
  .component('motion', Motion)
  .component('aether-icon', AetherIcon);

app.mount('#app')
//初始化Aos动画
app.config.globalProperties.$aos = AOS;
AOS.init({
  duration: 1000,       // 动画时长
  once: true,           // 是否只执行一次
  offset: 200,          // 触发偏移量
  easing: 'ease-in-out', // 缓动效果
  delay: 0,              // ⚠️ 全局延迟设为 0（避免覆盖元素级 data-aos-delay）
  mirror: false,         // 🔥 滚动回顶部时是否反向播放动画（建议关闭）
  anchorPlacement: 'top-bottom', // 🔍 定义元素与视口位置关系（默认值）
  disable: window.innerWidth < 768 // 📱 移动端禁用（可选）
});

//判断视口
const isMobile = window.innerWidth < 768;
if (!isMobile) {
  console.log('不是移动端访问');
  // window.location.href = '/mobile.html';
}